import {
  Button,
  Calendar,
  Card,
  Checkbox,
  InputText,
  Tooltip,
} from '@agro1desenvolvimento/react-components';
import { useLocation } from 'react-router-dom';
import { TetrazolioHookData } from '../../../hooks/useTetrazolio';
import { CanteiroAreiaHookData } from '../../../hooks/useCanteiroAreia';
import FiltroSementesHeader from './FiltroSementesHeader';

interface Props {
  tetrazolioData: TetrazolioHookData;
  canteiroAreiaData: CanteiroAreiaHookData;
}

export default function FiltroSementes({ tetrazolioData, canteiroAreiaData }: Props) {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const activeTab = searchParams.get('tab');

  const activeData = activeTab === 'canteiro-areia' ? canteiroAreiaData : tetrazolioData;
  const { formik } = activeData;

  return (
    <Card className="lista-sementes-filtro">
      <FiltroSementesHeader tetrazolioData={activeData} />
      <form onSubmit={formik.handleSubmit}>
        <div className="form">
          <div className="form-row">
            <div className="form-field">
              <label style={{
                display: 'flex', flexDirection: 'row', gap: '8px', alignItems: 'center',
              }}
              >Buscar
                <Tooltip
                  style={{ maxWidth: '220px' }}
                  target=".search-help-icon"
                  position="right"
                  content="Busque por Requerente, Espécie, Nº Amostra, Nº Remessa, Nº Lote, Cultivar, Categoria, Nome Científico"
                />
                <i className="search-help-icon pi pi-info-circle" />
              </label>
              <InputText
                name="search"
                value={formik.values.search}
                onChange={formik.handleChange}
              />
            </div>
            <div className="form-field">
              <label>Período de Recebimento</label>
              <div className="form-input-group">
                <div className="calendar-with-label">
                  <span className="calendar-label">De:</span>
                  <Calendar
                    name="dataInicio"
                    value={formik.values.dataInicio}
                    onChange={(e) => formik.setFieldValue('dataInicio', e.value)}
                    dateFormat="dd/mm/yy"
                    showIcon
                  />
                </div>
                <div className="calendar-with-label">
                  <span className="calendar-label">Até:</span>
                  <Calendar
                    name="dataFim"
                    value={formik.values.dataFim}
                    onChange={(e) => formik.setFieldValue('dataFim', e.value)}
                    dateFormat="dd/mm/yy"
                    showIcon
                  />
                </div>
              </div>
              {formik.errors.dataInicio && formik.touched.dataInicio && (
                <small style={{ color: 'red' }}>{formik.errors.dataInicio}</small>
              )}
              {formik.errors.dataFim && formik.touched.dataFim && (
                <small style={{ color: 'red' }}>{formik.errors.dataFim}</small>
              )}
            </div>
            <div className="form-field">
              <label>Status</label>
              <div className="form-input-group">
                <div>
                  <Checkbox
                    inputId="statusPendente"
                    name="statusPendente"
                    checked={formik.values.statusPendente}
                    onChange={formik.handleChange}
                  />
                  <p className="checkbox-label">Pendente</p>
                </div>
                <div>
                  <Checkbox
                    inputId="statusIniciado"
                    name="statusIniciado"
                    checked={formik.values.statusIniciado}
                    onChange={formik.handleChange}
                  />
                  <p className="checkbox-label">Iniciado</p>
                </div>
                <div>
                  <Checkbox
                    inputId="statusRealizado"
                    name="statusRealizado"
                    checked={formik.values.statusRealizado}
                    onChange={formik.handleChange}
                  />
                  <p className="checkbox-label">Realizado</p>
                </div>
              </div>
              {formik.errors['at-least-one-status'] && (
                <small style={{ color: 'red', display: 'block', marginTop: '4px' }}>
                  {formik.errors['at-least-one-status']}
                </small>
              )}
            </div>
          </div>
          <Button type="submit" className="form-button">
            Aplicar
          </Button>
        </div>
      </form>
    </Card>
  );
}
